import { STRING } from 'customer-data-objects/property/PropertyTypes';
import I18n from 'I18n';
import { List } from 'immutable';
import { EnumerationDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
export const makeImportMembershipField = (options = []) => {
  return DSFieldRecord({
    displayType: EnumerationDisplayType,
    label: I18n.text(`newCustomerDataFilters.specialFields.IMPORT.hs_import_membership`),
    name: 'hs_import_membership',
    type: STRING,
    options: List(options)
  });
};